<template>
  <div v-if="surveySelected" :class="surveyWrapperClass" :style="surveyWrapperStyle">
    <div v-if="isRokuSurvey" class="rf-survey-button-group">
      <button
        v-for="n in optionsTotal"
        :key="n"
        type="button"
        class="rf-survey-button"
        :style="getRokuButtonStyle(n)"
        @focus="focusedOption = n"
        @blur="focusedOption = null"
      >
        {{ getLabelByPosition(n) }}
      </button>
    </div>
    <div v-else class="rf-radio-group">
      <div v-for="n in optionsTotal" :key="n" class="rf-radio-item" :style="surveyStyle">
        <input
          v-if="getValueByPosition(n)"
          :id="`survey-option-${n}`"
          type="radio"
          name="survey"
          :style="radioBtnStyle"
          :value="getValueByPosition(n)"
          @click="clickRadio($event)"
        />
        <label v-if="getValueByPosition(n)" :for="`survey-option-${n}`">
          {{ getLabelByPosition(n) }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import SurveyMixin from "@/utils/SurveyMixin";
import { DefaultDeviceOptions } from "@/utils/constants/DevicesConstants";

export default {
  name: "RfPromoSurveyPreview",
  mixins: [SurveyMixin],
  props: ["actions", "isMobile", "deviceType"],
  data() {
    return {
      focusedOption: null,
    };
  },
  computed: {
    isRokuSurvey() {
      return this.deviceType === DefaultDeviceOptions.roku_os.value;
    },
    screenWiseTextSize() {
      return !this.isMobile
        ? this.actions.rf_retention_survey_options_font_size
        : this.actions.rf_settings_mobile_message_font_size;
    },
    surveyStyle() {
      return {
        "color": this.actions.rf_settings_fill_color,
        "font-size": this.screenWiseTextSize,
      };
    },
    radioBtnStyle() {
      return {
        "width": this.screenWiseTextSize,
        "height": this.screenWiseTextSize,
        "border-color": this.actions.rf_settings_fill_color,
        "background": "initial",
        "margin": 0,
        "margin-right": "0.8em",
      };
    },
    surveyWrapperStyle() {
      const topMargin = this.actions.rf_retention_survey_top_margin;
      return topMargin ? { "margin-top": topMargin } : {};
    },
    surveyWrapperClass() {
      return [
        {
          "survey-wrapper": true,
        },
        {
          "center-align-mode": this.actions.rf_retention_align === "center",
          "right-align-mode": this.actions.rf_retention_align === "right",
        },
      ];
    },
  },
  watch: {
    deviceType() {
      this.focusedOption = null;
    },
  },
  methods: {
    getValueByPosition(n) {
      return this.actions[`rf_retention_survey_option_${n}_value`];
    },
    getLabelByPosition(n) {
      return this.actions[`rf_retention_survey_option_${n}_label`];
    },
    clickRadio({ target }) {
      document.getElementsByName(target.name).forEach(el => {
        el.style.background = "initial";
      });
      const { checked } = target;
      if (checked) {
        target.style.background = this.actions.rf_settings_fill_color;
      }
    },
    getRokuButtonStyle(n) {
      const isFocused = this.focusedOption === n;
      const defaultBg = this.actions.rf_settings_fill_color || "#666666";
      return {
        "background-color": isFocused
          ? this.actions.button1_focus_bg_color || this.actions.button1_bg_color || defaultBg
          : this.actions.button1_bg_color || defaultBg,
        "color": isFocused
          ? this.actions.button1_highlight_color || this.actions.button1_text_color || "#FFFFFF"
          : this.actions.button1_text_color || "#FFFFFF",
        "font-size": this.screenWiseTextSize,
      };
    },
  },
};
</script>

<style scoped>
.rf-survey-button-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.4em;
  width: 100%;
}

.rf-survey-button {
  border: none;
  cursor: pointer;
  padding: 0.5em 1em;
  width: 100%;
  text-align: left;
}
</style>
